import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import ExploreItem from "../ExploreItem/ExploreItem";
import GenerateCollectionModal from "../GenerateCollectionModal/GenerateCollectionModal";
import EditImageModal from "../EditImageModal/EditImageModal";
import { selectLoggedIn } from "../../store/slices/auth/slice";
import { setSignUpModalOpen } from "../../store/slices/common/slice";
import {
  selectSelectedCollection,
  setSelectedCollection,
} from "../../store/slices/model/slice";
import useSeoTemplates from "../../hooks/useSeoTemplates";
import { isImageOutput } from "../../utils/utils";
import {
  LoadingCard,
  LoadingGrid,
  ShelfCopy,
  ShelfEyebrow,
  ShelfGrid,
  ShelfHeader,
  ShelfLink,
  ShelfSection,
  ShelfText,
  ShelfTitle,
} from "./SeoTemplateShelf.styles";

const SeoTemplateShelf = ({
  title,
  description,
  preferredKeyword,
  itemCount = 4,
}) => {
  const dispatch = useDispatch();
  const loggedIn = useSelector(selectLoggedIn);
  const selectedCollection = useSelector(selectSelectedCollection);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [isGenerateCollectionModalOpen, setIsGenerateCollectionModalOpen] =
    useState(false);
  const [isEditImageModalOpen, setIsEditImageModalOpen] = useState(false);
  const { templates, loading } = useSeoTemplates({
    preferredKeyword,
    itemCount,
  });

  const handleItemClick = useCallback(
    (item) => {
      if (!item) return;

      if (!loggedIn) {
        dispatch(setSignUpModalOpen(true));
        return;
      }

      dispatch(setSelectedCollection(item));

      if (isImageOutput(item.modelType ?? item.modelName)) {
        setIsEditImageModalOpen(true);
      } else {
        setIsGenerateCollectionModalOpen(true);
      }
    },
    [dispatch, loggedIn],
  );

  if (!loading && !templates.length) {
    return null;
  }

  return (
    <>
      <ShelfSection>
        <ShelfHeader>
          <ShelfCopy>
            <ShelfEyebrow>Featured Templates</ShelfEyebrow>
            <ShelfTitle>{title}</ShelfTitle>
            <ShelfText>{description}</ShelfText>
          </ShelfCopy>

          <ShelfLink to="/">See More Templates</ShelfLink>
        </ShelfHeader>

        {loading ? (
          <LoadingGrid>
            {Array.from({ length: itemCount }).map((_, index) => (
              <LoadingCard key={index} />
            ))}
          </LoadingGrid>
        ) : (
          <ShelfGrid>
            {templates.map((item) => (
              <ExploreItem
                key={item._id}
                item={item}
                isMobile={isMobile}
                onItemClick={() => handleItemClick(item)}
              />
            ))}
          </ShelfGrid>
        )}
      </ShelfSection>

      <GenerateCollectionModal
        isOpen={isGenerateCollectionModalOpen}
        onClose={() => setIsGenerateCollectionModalOpen(false)}
      />

      <EditImageModal
        isOpen={isEditImageModalOpen}
        collection={selectedCollection}
        onClose={() => setIsEditImageModalOpen(false)}
      />
    </>
  );
};

export default SeoTemplateShelf;
